import { useCallback } from 'react';
import { flowsApi } from 'apis/flows';
import { integrationsApi } from 'apis/integrations';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { createEmailPayload } from './helper';
/** A hook that handles duplicating an email. */
export const useDuplicateEmail = () => {
    const dispatch = useAppDispatch();
    const duplicateEmail = useCallback((state, email) => {
        const [emailFlow] = email.flows;
        const payload = createEmailPayload(state);
        return Promise.all([
            dispatch(integrationsApi.endpoints.createEmailIntegration.initiate(payload)),
            dispatch(flowsApi.endpoints.readFlow.initiate({ id: emailFlow.id })),
        ]);
    }, [dispatch]);
    return duplicateEmail;
};
